import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from 'src/app/Services/Translation/Translation.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'embryo-DealOfTheDay',
  templateUrl: './DealOfTheDay.component.html',
  styleUrls: ['./DealOfTheDay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealOfTheDayComponent implements OnInit {

   @Input() singleProduct : any; 

   @Input() currency : string;
   @Input() exchangeMX:number

   counterDateTime = new Date(new Date().setHours(20,0,0,0));



   constructor(public trans:TranslationService,public translate:TranslateService) {}

   ngOnInit() {
   }

   /**
    * getOfferImagePath is used to change the image path on click event. 
    */
   public getOfferImagePath(imgPath: any, index:number) {
      $('.selected_img').removeClass('border-active');
      this.singleProduct.image = imgPath;
      $("#"+index+"_img").addClass('border-active');
   }

}
